module.exports = __webpack_public_path__ + "static/media/28.f5f4c700.png";